module.exports = __webpack_public_path__ + "media/images/seat_map_sc-8ddf250e511db8769cb7ce9d0f0b5d34.png";